import React from "react";
import { Container, Row, Col, Card, CardBody, Alert } from "reactstrap";
import CrearLaboratorio from "./CrearLaboratorio";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { DatosSesion } from "../../../Components/Common/DatosSesion";
   
const LaboratorioCrear = () => {
  document.title = "Crear Laboratorio | Farme";
  const perfil = DatosSesion("perfil");
  
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {perfil === "Administrador" ||
          perfil === "Farmacia" ||
          perfil === "MyHealth" ? (
            <>
              <BreadCrumb
                title="Crear Laboratorio"
                pageTitle="Listar Laboratorios"
                url="/laboratorios"
              />
              <Row>
                <Col lg={12}>
                  <Card>
                    <CardBody>
                      <CrearLaboratorio />
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </>
          ) : (
            <Alert color="danger">
              No tienes permisos para ver esta página.
            </Alert>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default LaboratorioCrear;